// libraries
import React from 'react'

// dependencies
import { Table } from '@st-operations/uikit/src/v2/index.js'

// style
import '../../css/components/CohortsBoard.styl'
import NavigationContext from '../contexts/NavigationContext.jsx'

// component
class SyntheticUsersBoardComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      sort_dir: -1,
      sort_key: '',
    }
  }

  componentDidMount() {
    // hide navigation
    this.props.setShowSidebar(false)
    window._api.get(`/data-explorer/statistics`, (error, statistics) => {
      if (error) {
        toast.error(error.message)
      }

      if (statistics) {
        this.setState({
          statistics,
        })
      }
    })
  }

  onSort = (key) => {
    let { sort_dir, sort_key } = this.state

    if (key === sort_key) {
      this.setState({ sort_dir: sort_dir * -1 })
    } else {
      this.setState({ sort_key: key, sort_dir: 1 })
    }
  }

  sortTable = (objs) => {
    let { sort_dir, sort_key } = this.state
    if (sort_dir === 1) {
      objs.sort((a, b) => (a[sort_key] > b[sort_key] ? 1 : b[sort_key] > a[sort_key] ? -1 : 0))
    } else {
      objs.sort((a, b) => (a[sort_key] < b[sort_key] ? 1 : b[sort_key] < a[sort_key] ? -1 : 0))
    }
  }

  render() {
    let { sort_dir, sort_key, statistics } = this.state
    let { table_data } = this.props
    if (
      table_data &&
      Object.keys(table_data.rows).length === 0 &&
      Object.keys(table_data.columns).length === 1
    ) {
      table_data.columns = {}
    }

    // format columns to pass to table
    // sort the data whenever sort key clicks
    let columns = []
    if (table_data && 'columns' in table_data) {
      columns = table_data.columns.map((name) => {
        return { name, key: name, sortable: true }
      })
      if (sort_key !== '') {
        this.sortTable(table_data.rows)
      }
    }
    // let table_width = columns.length * 140
    return (
      <div className="dataexplore-board">
        <h3>DATA PREVIEW</h3>
        <div className="dataexplore-board-datapreview">
          <If condition={table_data && table_data.columns}>
            <Table
              columns={columns}
              data={table_data.rows}
              onSort={this.onSort}
              sort_dir={sort_dir}
              sort_key={sort_key}
            />
          </If>
        </div>
        <If condition={table_data && statistics}>
          <div className="dataexplore-board-statistics">
            {/* <div className="dataexplore-board-card">
              <h2>Top Events</h2>
              {statistics.top_event_type.map((item, i) => {
                return (
                  // eslint-disable-next-line react/jsx-key
                  <div key={i}>
                    <span>{item.key}</span><span>{item.doc_count}</span>
                  </div>
                )
              })}
            </div> */}
            <div className="dataexplore-board-card">
              <h2>Top Users</h2>
              <h4>TTD ID Count: {statistics.ttdid_count.value}</h4>
              <h4>ShareThis ID Count: {statistics.domains_count.value}</h4>
              <h4>Andriod ID Count: {statistics.andriodid_count.value}</h4>
            </div>
            <div className="dataexplore-board-card">
              <h2>Top Country</h2>
              {statistics.top_country_count.map((item, i) => {
                return (
                  // eslint-disable-next-line react/jsx-key
                  <div key={i}>
                    <span>{item.key}</span>
                    <span>{item.doc_count}</span>
                  </div>
                )
              })}
            </div>
            {/* <div className="dataexplore-board-card">
              <h2>Top Domains</h2>
              <h4>Domains Count: {statistics.domains_count.value}</h4>
              <h4>URL Count: {statistics.url_count.value}</h4>
              {statistics.top_domains_count.map((item, i) => {
                return (
                  // eslint-disable-next-line react/jsx-key
                  <div key={i}>
                    <span>{item.key}</span><span>{item.doc_count}</span>
                  </div>
                )
              })}
            </div> */}
            <div className="dataexplore-board-card">
              <h2>Top Keywords</h2>
              {statistics.top_keywords_count.map((item, i) => {
                return (
                  // eslint-disable-next-line react/jsx-key
                  <div key={i}>
                    <span>{item.key}</span>
                    <span>{item.doc_count}</span>
                  </div>
                )
              })}
            </div>
          </div>
        </If>
      </div>
    )
  }
}

const SyntheticUsersBoard = (props) => (
  <NavigationContext.Consumer>
    {({ setShowSidebar }) => (
      <SyntheticUsersBoardComponent {...props} setShowSidebar={setShowSidebar} />
    )}
  </NavigationContext.Consumer>
)

// export
export default SyntheticUsersBoard
